// Frozen snapshot of the /integrations catalog response.
// Used when the VUE_APP_FEATURE_INTEGRATIONS_CATALOG_MOCK feature flag is enabled,
// so the catalog serves this static payload instead of hitting the live API.
export const integrationsCatalogMock = {
  success: true,
  data: {
    categories: [
      {
        id: '407189021885',
        name: 'Workflow & Automations',
        slug: 'workflow-automations',
        order: 1,
        items: [
          {
            slug: 'jira',
            name: 'Jira',
            label: 'Jira Ticket from Alerts',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Jira.svg',
            shortDescription:
              'Easily create Jira tickets from alerts and manage your alert workflow',
            order: 1,
            displayIndex: 1,
            category: {
              id: '1',
              name: 'Workflow & Automations',
            },
            cta: {
              kind: 'connect',
              providerKey: 'jira',
              name: 'connect',
              accessPermissions: [],
            },
            permissions: ['alert_get', 'alert_list', 'alert_modify'],
            overview:
              '<span>Close the gap between threat detection and resolution. Efficiently manage and customize your alerts workflow. This integration allows your compliance teams to transform Global Ledger alerts into actionable Jira tickets, ensuring every risk is tracked to completion.</span>',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/jira-desc-2.png',
            keyFeatures:
              '<ul>\n<li><span>One-click Jira ticket creation from the Global Ledger alerts dashboard.</span></li>\n<li><span>Automatic mapping of alert data to Jira ticket description.</span></li>\n<li><span>Easy overview and filtering of Global Ledger alerts by Jira ticket creation status. </span></li>\n</ul>',
            howItWorks:
              '<p><span><strong>How to Use Jira for Alerts</strong></span><span></span></p>\n<p>&nbsp;</p>\n<p><span><strong>Step 1</strong>: Start by connecting your Jira account via the Connect button above.</span></p>\n<p><span><strong>Step 2</strong>: </span>Select the Jira domain, project and issue type that will be used to create Jira tickets from alerts.</p>\n<p><strong>Step 3</strong>: Once configuration is complete, go to the Alerts dashboard within Global Ledger, select the desired alert(s) and click Create Jira Tickets.</p>\n<p><strong>Step 4</strong>: If a Jira ticket is created for a specific alert, you will see the Jira symbol next to it, and you will be able to navigate directly to the Jira ticket through the hyperlink.</p>',
            howItWorksScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/jira-desc-1.png',
          },
          // {
          //   slug: 'slack',
          //   name: 'Slack',
          //   label: 'Instant Alert Notifications',
          //   logoUrl:
          //     'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Slack.svg',
          //   shortDescription:
          //     'Get alerts directly into Slack to keep updated real-time on the risks',
          //   order: 2,
          //   displayIndex: 2,
          //   category: {
          //     id: '1',
          //     name: 'Workflow & Automations',
          //   },
          //   cta: {
          //     kind: 'connect',
          //     providerKey: 'slack',
          //     name: 'connect',
          //     accessPermissions: [],
          //   },
          //   permissions: ['alert_get', 'alert_list', 'alert_modify'],
          //   overview:
          //     '<span>Bring risk intelligence into the heart of your team’s communication. Receive instant, high-fidelity transaction alerts directly in Slack to ensure your team never misses a critical event.</span>',
          //   overviewScreenshotUrl:
          //     'https://blog.globalledger.io/hubfs/Integrations/Slack-desc-1.png',
          //   keyFeatures:
          //     '<ul>\n<li><span>One-click setup.</span></li>\n<li><span>Real-time notifications in Slack for Global Ledger alerts.</span></li>\n<li><span>Interactive alert cards in Slack with direct links to the Global Ledger dashboard.</span></li>\n</ul>',
          //   howItWorks:
          //     '<p><span><strong>Step 1</strong>: Start by connecting your Slack account via the Connect button above. </span></p>\n<p><span><em>Note: depending on your organizational policy, you might have to request approval from your Slack workspace admin.</em></span></p>\n<p><span><strong>Step 2</strong>: You will be redirected to the Slack application, directly to the chat with the Global Ledger Notifications App.</span></p>\n<p><strong>Step 3</strong>: You will now receive all new Global Ledger alerts into this chat.</p>',
          //   howItWorksScreenshotUrl: null,
          // },
          {
            slug: 'power-bi',
            name: 'Microsoft Power BI',
            label: 'Insights and Analysis',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Power%20BI.svg',
            shortDescription:
              'Executive insights and visualizations for your Global Ledger data',
            order: 3,
            displayIndex: 3,
            category: {
              id: '1',
              name: 'Workflow & Automations',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              '<span>Transform raw risk intelligence into executive-ready insights. By funneling your Global Ledger check history and alert data directly into Power BI, you can build powerful, real-time visualizations to maintain complete oversight of your compliance operations and KPI trends.</span>',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/PowerBi-desc-1.png',
            keyFeatures:
              '<ul>\n<li><span><strong>Ready-to-Use Templates:</strong> Deploy pre-set Power BI templates designed specifically for Global Ledger data.</span></li>\n<li><span><strong>Custom Analytics</strong>: Visualize address checks, transaction data, and historical alerts using pre-built charts or build your own from scratch.</span></li>\n<li><span><strong>Unified Compliance Dashboard:</strong> Centralize your crypto risk data alongside other corporate business intelligence in a single pane of glass.</span></li>\n</ul>',
            howItWorks:
              '<p><span><strong>Step 1</strong>: Contact us to get the Global Ledger Power BI templates and open them in your Power BI Desktop or Web application. </span></p>\n<p><span><strong>Step 2</strong>: Enter your Global Ledger API key when prompted.</span></p>\n<p><span><strong>Step 3</strong>: The dashboards will automatically fetch, map, and visualize your latest risk check and alert data.</span></p>',
            howItWorksScreenshotUrl: null,
          },
          // {
          //   slug: 'telegram',
          //   name: 'Telegram',
          //   label: 'Instant Alert Notifications',
          //   logoUrl:
          //     'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Telegram.svg',
          //   shortDescription:
          //     'Get real-time alert updates into Telegram to stay updated on the go',
          //   order: 11,
          //   displayIndex: 11,
          //   category: {
          //     id: '1',
          //     name: 'Workflow & Automations',
          //   },
          //   cta: {
          //     kind: 'connect',
          //     providerKey: 'telegram',
          //     name: 'connect',
          //     accessPermissions: [],
          //   },
          //   permissions: ['alert_get', 'alert_list', 'alert_modify'],
          //   overview:
          //     "<p><span>Stay ahead of risks, even when you're away from your desk. The Telegram integration provides a mobile-first alert stream for real-time updates on your transactions.</span></p>",
          //   overviewScreenshotUrl:
          //     'https://blog.globalledger.io/hubfs/Integrations/telegram-desc-1.png',
          //   keyFeatures:
          //     '<ul>\n<li><span>Instant push notifications for all Global Ledger transaction alerts.</span></li>\n<li><span>Secure, encrypted delivery of risk summaries.</span></li>\n<li><span>Lightweight setup for on-the-go monitoring.</span></li>\n</ul>',
          //   howItWorks:
          //     '<p><span><strong>Step 1</strong>: Start by connecting your Telegram account via the Connect button above.</span><br><span></span></p>\n<p><span><strong>Step 2</strong>: You will be redirected to the Telegram application, directly to the chat with the Global Ledger Notifications bot.</span></p>\n<p><strong>Step 3</strong>: You will now receive all new Global Ledger alerts into this chat.</p>',
          //   howItWorksScreenshotUrl: null,
          // },
          {
            slug: 'zapier',
            name: 'Zapier',
            label: 'No-Code Integrations',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Zapier.svg',
            shortDescription:
              'Integrate productivity software with Global Ledger with no-code interface',
            order: 12,
            displayIndex: 12,
            category: {
              id: '1',
              name: 'Workflow & Automations',
            },
            cta: {
              kind: 'hyperlink',
              externalUrl: 'https://zapier.com/apps/global-ledger/integrations',
              name: 'explore',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              '<span>Automate your compliance stack without writing a single line of code. Connect Global Ledger to 5,000+ apps to create custom workflows that fit your unique business needs.</span>',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/zapier-desc-2.png',
            keyFeatures:
              '<ul>\n<li><span>No-code automation for compliance workflows.</span></li>\n<li><span>Connect with productivity, communication, CRM, and Database tools.</span></li>\n<li><span>Use our pre-built Zapier templates or create your own workflow.</span></li>\n</ul>',
            howItWorks:
              '<p><span><strong>Step 1</strong>: Enable your Zapier account </span></p>\n<p><span><strong>Step 2</strong>: Create a “Zap” (automated workflow) between Global Ledger and another tool (e.g. Google Sheets). You can use our existing templates or create your own workflow. Note: you will need your Global Ledger API key, which is available in the My Account section.</span><br><span></span></p>\n<p><span><strong>Step 3</strong>: Now you can use Global Ledger data in your favourite productivity applications.</span></p>\n<p>For more details, check our <a href="https://vision.glprotocol.com/user-guide" target="_blank" rel="noopener noreferrer">Global Ledger - Zapier Integration User Guide</a> as well as our <a href="https://www.youtube.com/playlist?list=PLVWQJ93nsLYWr1UlTlLjkxWOepPkM8Ddf" target="_blank" rel="noopener noreferrer">YouTube channel</a>. Feel free to contact us if you have any additional automation needs in Zapier - we will be happy to help!</p>',
            howItWorksScreenshotUrl: null,
          },
          {
            slug: 'palantir',
            name: 'Palantir Foundry',
            label: 'Tracing Graphs Export',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Palantir.svg',
            shortDescription:
              '<p style="line-height: 1.2;">Investigation graphs export optimized for Palantir Foundry use</p>',
            order: 15,
            displayIndex: 15,
            category: {
              id: '1',
              name: 'Workflow & Automations',
            },
            cta: {
              kind: 'hyperlink',
              externalUrl: 'https://vision.glprotocol.com/analytics',
              name: 'export',
              accessPermissions: [],
            },
            permissions: ['tracing_get'],
            overview:
              '<span>Take your forensic investigations to the next level. Export complex Global Ledger Tracing graphs in a structure optimized for Palantir Foundry for advanced data correlation and large-scale investigative analysis.</span>',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/palantir-desc-2.png',
            keyFeatures:
              '<ul>\n<li><span>Optimized data structure for Palantir Foundry ingestion.</span></li>\n<li><span>Lossless transfer of transaction relationships, as well as wallet and transaction risk data.</span></li>\n<li><span>Support for large-scale forensic visualizations.</span></li>\n</ul>',
            howItWorks:
              '<p><span><strong>Step 1</strong>: After completing a Tracing investigation in Global Ledger, select the Palantir export option. </span></p>\n<p><span><strong>Step 2</strong>: The system will generate a zip folder with three csv files that are optimized for the Palantir Foundry Ontology, allowing you to merge blockchain data with other proprietary datasets.</span></p>\n<p><span>For detailed information, consult our <a href="https://vision.glprotocol.com/user-guide" target="_blank" rel="noopener noreferrer">user guide</a>. </span></p>',
            howItWorksScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/palantir-desc-1.png',
          },
          {
            slug: 'gl-lens',
            name: 'GL Lens',
            label: 'Browser Extension',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Chrome.svg',
            shortDescription:
              'Identify wallet risk on any webpage with our Chrome extension',
            order: 17,
            displayIndex: 17,
            category: {
              id: '1',
              name: 'Workflow & Automations',
            },
            cta: {
              kind: 'hyperlink',
              externalUrl:
                'https://chromewebstore.google.com/detail/gl-lens-web3-risk-aml-che/kmfhkhkfgehkamfnjnhkdhfdgidgobbe',
              name: 'install',
              accessPermissions: ['lens_extension_get'],
            },
            permissions: [],
            overview:
              '<span>Risk intelligence, anywhere you browse. GL Lens is a proprietary browser extension that instantly identifies blockchain address risk on any webpage, from block explorers to OTC desks.</span>',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/gl-lens-desc-1.png',
            keyFeatures:
              '<ul>\n<li><span>Instant on-page address detection and highlighting.</span></li>\n<li><span>Colour-coded risk indicators and hover-to-view entity details and risk labels.</span></li>\n<li><span>Direct links to deep-dive reports, tracing and monitoring in Global Ledger.</span></li>\n</ul>',
            howItWorks:
              "<p><span><strong>Step 1</strong>: Click on the Connect button above, install the extension from the Chrome Web Store and log in. <em>Note: if your plan doesn't have GL Lens included, contact us for more information</em></span></p>\n<p><span><strong>Step 2</strong>: As you browse, GL Lens scans the page for crypto addresses.</span></p>\n<p><span><strong>Step 3</strong>: Simply click or hover over a detected address to see its current risk profile immediately.</span></p>\n<p><span><strong>Step 4</strong>: Navigate to full risk report, tracing graph or add address to monitoring by clicking on the buttons.&nbsp;</span></p>",
            howItWorksScreenshotUrl: null,
          },
          {
            slug: 'maltego',
            name: 'Maltego',
            label: 'Investigation Graph',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Maltego.svg',
            shortDescription:
              'Cyber forensics enriched with our wallet and transaction intelligence.',
            order: 21,
            displayIndex: 21,
            category: {
              id: '1',
              name: 'Workflow & Automations',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              'Supercharge your cyber forensics and threat intelligence with link-analysis data. This integration provides a specialized package of Local Transforms that allows investigators to map, visualize, and correlate Global Ledger’s deep wallet and transaction intelligence directly within their Maltego Graph workspace.',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/maltego-desc.png',
            keyFeatures:
              '<ul>\n<li><strong>Privacy-First Data Fetching:</strong><span> Run Local Transforms directly on your machine, ensuring query parameters interact solely between your client and Global Ledger’s API without traversing third-party servers.</span><br><span></span></li>\n<li><strong>On-Chain Node Expansion:</strong> Instantly transform crypto addresses or transaction inputs into detailed nodes showing entity labels, historical risks, and transaction pathways.</li>\n<li><strong>Multi-Source Correlation:</strong> Overlay Global Ledger’s risk profiles with existing OSINT, threat intelligence, and corporate infrastructure datasets already on your graph.</li>\n</ul>',
            howItWorks:
              '<p><strong>Step 1</strong>: Contact us to download and install the Global Ledger Local Transform package on your local machine.</p>\n<p><strong>Step 2</strong>: Input your Global Ledger API key into the script configuration settings.</p>\n<p><strong>Step 3</strong>: Once activated, simply right-click any crypto wallet or transaction hash on your graph to run a Transform and automatically pull real-time data from our system.</p>\n<p>Check our <a href="https://vision.glprotocol.com/user-guide" target="_blank" rel="noopener noreferrer">user guide</a> for more details.&nbsp;</p>',
            howItWorksScreenshotUrl: null,
          },
        ],
      },
      {
        id: '407189021886',
        name: 'Digital Assets Infrastructure',
        slug: 'digital-assets-infrastructure',
        order: 2,
        items: [
          {
            slug: 'dfns',
            name: 'Dfns',
            label: 'Risk-Based Transaction Management',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Dfns.svg',
            shortDescription:
              '<p style="line-height: 1.2;">Natively integrated risk scores for transaction policy management</p>',
            order: 4,
            displayIndex: 4,
            category: {
              id: '2',
              name: 'Digital Assets Infrastructure',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              '<span>Harden your digital asset security by embedding risk intelligence into your Wallet-as-a-Service workflow. Manage transaction policies within Dfns using natively integrated Global Ledger risk scores and alerts to prevent illicit transfers.</span>',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/dfns-desc.png',
            keyFeatures:
              '<ul>\n<li><span>Native risk scoring of destination wallets within the Dfns interface.</span></li>\n<li><span>Policy-based pre-execution blocking of outgoing transactions based on Global Ledger data.</span></li>\n<li><span>Automated risk assessment and alert information for every outgoing request.</span></li>\n<li><span>Global Ledger supports automatic addition of every new Dfns wallet to alerts and monitoring. </span></li>\n</ul>',
            howItWorks:
              '<h3><span>How to manage transaction risk within Dfns based on wallet risk profiles:</span></h3>\n<p><span><strong>Step 1:</strong> Insert your Global Ledger API Key in the Dfns dashboard.</span></p>\n<p><span><strong>Step 2: </strong>Set up your desired Dfns transaction policy to automatically approve, flag, or reject transactions based on the destination wallet risk score.</span></p>\n<span><strong>Step 3: </strong>Global Ledger wallet risk scores and alerts will now be fed directly into the Dfns policy engine.</span><br><br>\n<p><span>For more information, check <a href="https://docs.dfns.co/integrations/aml-kyt/global-ledger" target="_blank" rel="noopener noreferrer">Dfns user guide</a>. </span></p>\n<br>\n<h3><span>How to automatically add new Dfns wallets to alerts and monitoring</span></h3>\n<p><span><strong>Step 1</strong>: Set up Monitoring Alerts in Global Ledger.</span><br><span></span></p>\n<p><span><strong>Step 2</strong>: Create a webhook for wallet created events within the Dfns dashboard.</span></p>\n<p><span><strong>Step 3</strong>: Deploy a small script to extract the new wallet hash and pass it to our dedicated Add to Monitoring endpoint.</span><br><span></span></p>\n<p><span><strong>Step 4</strong>: All new wallets will now be automatically added to your Global Ledger alerts and monitoring flow. </span></p>',
            howItWorksScreenshotUrl: null,
          },
          {
            slug: 'ibm',
            name: 'IBM Digital Asset Haven',
            label: 'Risk-Based Transaction Management',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=IBM%20Save%20Haven.svg',
            shortDescription:
              'Stay ahead of the transaction risks by using natively integrated risk scores',
            order: 5,
            displayIndex: 5,
            category: {
              id: '2',
              name: 'Digital Assets Infrastructure',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              '<p><span>Enterprise-grade security meets world-class risk intelligence. Leverage Global Ledger risk scores within IBM Digital Asset Haven to enforce rigorous transaction policies and institutional compliance.</span></p>',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/ibm-desc-1.png',
            keyFeatures:
              '<ul>\n<li><span>Deep integration with IBM Digital Asset Haven policy framework.</span></li>\n<li><span>Institutional-level risk monitoring for outbound transactions.</span></li>\n<li><span>Seamless data flow between Global Ledger and IBM’s secure environment.</span></li>\n</ul>',
            howItWorks:
              '<p><span><strong>Step 1</strong>: Insert your Global Ledger API Key in the IBM Safe Haven dashboard.</span><br><span></span></p>\n<p><span><strong>Step 2</strong>: Set up your desired IBM Safe Haven transaction policy to automatically approve, flag, or reject transactions based on the destination wallet risk score.</span></p>\n<p><strong>Step 3</strong>: Global Ledger wallet risk scores will now be fed directly into the IBM Safe Haven policy engine.</p>\n<br>\n<p><span>For more information, check <a href="https://www.ibm.com/docs/en/daw/1.1.0?topic=concepts-policies" target="_blank" rel="noopener noreferrer">IBM Digital Asset Haven user guide</a>. </span></p>',
            howItWorksScreenshotUrl: null,
          },
          {
            slug: 'utila',
            name: 'Utila',
            label: 'Risk-Based Transaction Management',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Utila.svg',
            shortDescription:
              'Self-hosted integration bridge to stop risky transactions before execution',
            order: 6,
            displayIndex: 6,
            category: {
              id: '2',
              name: 'Digital Assets Infrastructure',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              '<span>Stop risky transactions before they hit the chain. Using our self-hosted integration bridge, Utila users can intercept and block high-risk transfers based on real-time intelligence.</span>',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/utila-desc-1.png',
            keyFeatures:
              '<ul>\n<li><span>Self-hosted bridge for enhanced data privacy.</span></li>\n<li><span>Pre-execution transaction blocking.</span></li>\n<li><span>Customizable risk thresholds for automated gatekeeping.</span></li>\n</ul>',
            howItWorks:
              "<p><span><strong>Step 1:</strong> Deploy the Global Ledger integration bridge within your infrastructure.</span></p>\n<p><span><strong>Step 2</strong>: Configure your desired risk score threshold in the integration bridge, and then configure transaction policy rules in the Utila dashboard.</span></p>\n<p><span><strong>Step 3:</strong> The bridge checks Utila transaction requests against Global Ledger's risk database, preventing execution if the risk score exceeds your limit.</span></p>",
            howItWorksScreenshotUrl: null,
          },
          {
            slug: 'fireblocks',
            name: 'Fireblocks',
            label: 'Request an Integration',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Fireblocks.svg',
            shortDescription:
              'Digital asset and stablecoin infrastructure provider',
            order: 19,
            displayIndex: 19,
            category: {
              id: '2',
              name: 'Digital Assets Infrastructure',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              'Inject real-time blockchain intelligence into the world’s leading digital asset custody network. A native integration would allow you to evaluate destination address risks before executing transfers directly out of your Fireblocks vaults.',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/fireblocks-desc.png',
            keyFeatures:
              '<ul>\n<li><strong>Pre-Execution Gatekeeping:</strong> Block high-risk outward transactions directly within the Fireblocks Transaction Authorization Policy (TAP).</li>\n<li><strong>Automated Vault Labeling:</strong> Automatically assess and tag incoming deposits within hot or cold workspaces based on source risk.</li>\n<li><strong>Institutional Governance:</strong> Enforce strict AML risk boundaries across all enterprise-grade asset wallets.</li>\n</ul>',
            howItWorks:
              'Secure your institutional workflow by letting us know you want this. Click the <strong>Contact Us</strong> button above to vote for a native Global Ledger plugin inside the Fireblocks ecosystem.',
            howItWorksScreenshotUrl: null,
          },
        ],
      },
      {
        id: '407095286004',
        name: 'Travel Rule',
        slug: 'travel-rule',
        order: 3,
        items: [
          {
            slug: 'cryptoswift',
            name: 'Cryptoswift',
            label: 'Request an Integration',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Cryptoswift.svg',
            shortDescription:
              'A crypto Travel Rule &amp; KYT solution with transaction risk assessment',
            order: 7,
            displayIndex: 7,
            category: {
              id: '3',
              name: 'Travel Rule',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              'Bring automated AML intelligence into your Cryptoswift rule engine. By combining Global Ledger’s check history with Cryptoswift\'s cross-border compliance workflows, your team can automate routine approvals and focus entirely on high-risk exceptions.',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/cryptoswift-desc.png',
            keyFeatures:
              '<ul>\n<li><strong>Dynamic Policy Triggering:</strong><span> Seamlessly feed wallet risk scores into Cryptoswift’s automated compliance rule builder.</span></li>\n<li><strong>Pre- vs. Post-Transaction Analysis:</strong> Evaluate counterparty threat levels prior to moving assets on-chain.</li>\n<li><strong>Enhanced VASP Directory Context:</strong> Supplement Cryptoswift’s global VASP intelligence with deeper transaction-level data.</li>\n</ul>',
            howItWorks:
              '<p>If you want your compliance stack to rely on Cryptoswift and Global Ledger integration, let us know! Click <strong>Contact Us</strong> button above to submit your interest, allowing us to align our feature roadmap with your production needs.</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>',
            howItWorksScreenshotUrl: null,
          },
          {
            slug: '21-analytics',
            name: '21 Analytics',
            label: 'Risk-Aware Travel Rule',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=21Analytics.svg',
            shortDescription:
              '<p style="line-height: 1.25;">Get our wallet risk score within 21 Analytics Travel Rule solution</p>',
            order: 9,
            displayIndex: 9,
            category: {
              id: '3',
              name: 'Travel Rule',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              '<span>Enhance your Travel Rule compliance with market-leading wallet intelligence. By integrating Global Ledger risk scores into 21Analytics, you ensure every transfer is vetted for both regulatory data and financial crime risk.</span>',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/21-analytics-desc.png',
            keyFeatures:
              '<ul>\n<li><span>Automated wallet risk scoring within the 21Analytics solution.</span></li>\n<li><span>Unified view of Travel Rule data and AML risk.</span></li>\n<li><span>Streamlined "Know Your Transaction" (KYT) workflows.</span></li>\n</ul>',
            howItWorks:
              '<p><span><strong>Step 1</strong>: Enable Global Ledger as your risk data provider within the 21 Analytics settings according to the <a href="https://docs.21analytics.ch/8.0.4/deployment/risk_providers/global_ledger.html" target="_blank" rel="noopener noreferrer">user guide</a>. </span></p>\n<p><span><strong>Step 2</strong>: As you process Travel Rule messages, the platform will automatically fetch and display the Global Ledger risk score for the involved wallets.</span></p>',
            howItWorksScreenshotUrl: null,
          },
          {
            slug: 'ospree',
            name: 'Ospree',
            label: 'Risk-Aware Travel Rule',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Ospree.svg',
            shortDescription:
              'Get our wallet risk score and key risk information within Ospree',
            order: 10,
            displayIndex: 10,
            category: {
              id: '3',
              name: 'Travel Rule',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              '<span>Enhance your Travel Rule compliance with market-leading wallet intelligence. By integrating Global Ledger risk scores into Ospree, you ensure every transfer is vetted for both regulatory data and financial crime risk.</span>',
            overviewScreenshotUrl: null,
            keyFeatures:
              '<ul>\n<li><span>Automated wallet risk scoring within the Ospree solution.</span></li>\n<li><span>Key wallet risk information within the Ospree platform, which can be investigated further on Global Ledger.</span></li>\n<li><span>Unified view of Travel Rule data and AML risk.</span></li>\n</ul>',
            howItWorks:
              '<p><span><strong>Step 1</strong>: Enable Global Ledger as your risk data provider within the Ospree settings. </span></p>\n<p><span><strong>Step 2</strong>: The platform will automatically fetch and display the Global Ledger risk score and important risk information for the involved wallets.</span></p>',
            howItWorksScreenshotUrl: null,
          },
          {
            slug: 'notabene',
            name: 'Notabene',
            label: 'Request an Integration',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Notabene.svg',
            shortDescription:
              'Pre-transaction decisioning platform for Travel Rule compliance',
            order: 14,
            displayIndex: 14,
            category: {
              id: '3',
              name: 'Travel Rule',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              'Build a friction-free Travel Rule workflow by pairing Notabene’s leading VASP messaging network with Global Ledger\'s precise wallet risk intelligence. Help us prioritize this integration to automatically vet counterparty risk before your transactions are broadcast.',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/notabene-desc.png',
            keyFeatures:
              '<ul>\n<li><strong>Pre-Transaction Risk Routing:</strong><span> Instantly flag or approve incoming/outgoing Travel Rule transfers based on underlying wallet risk.</span></li>\n<li><strong>Unified Protocol Compliance:</strong> View Global Ledger risk ratings directly alongside Notabene IVMS data points.</li>\n<li><strong>Automated Escalations:</strong> Set rule-based logic to halt unhosted wallet transactions that exceed safety limits.</li>\n</ul>',
            howItWorks:
              '<p>Want to see Global Ledger risk data natively inside your Notabene interface? Click <strong>Contact Us</strong> and let us know! We track every customer request to coordinate development priorities directly with our platform partners.</p>\n<p>&nbsp;</p>',
            howItWorksScreenshotUrl: null,
          },
        ],
      },
      {
        id: '407095286005',
        name: 'All-In-One Compliance',
        slug: 'all-in-one-compliance',
        order: 4,
        items: [
          {
            slug: 'aml-watcher',
            name: 'AML Watcher',
            label: 'End-to-End Compliance Suite',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=AML%20Watcher.svg',
            shortDescription:
              '<p style="line-height: 1.2;">Comprehensive compliance with wallet risk scoring and monitoring</p>',
            order: 8,
            displayIndex: 8,
            category: {
              id: '5',
              name: 'All-In-One Compliance',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              '<p><span>A comprehensive compliance powerhouse. AML Watcher integrates Global Ledger’s native wallet risk scores and continuous monitoring to provide an all-in-one solution for seamless anti-money-laundering process.</span></p>',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/amlwatcher-desc-1.png',
            keyFeatures:
              '<ul>\n<li><span>Full-lifecycle wallet monitoring powered by Global Ledger.</span></li>\n<li><span>Integrated within AML screening, Travel Rule and Transaction Monitoring solutions.</span></li>\n<li><span>Dynamic risk scoring updated in real-time.</span></li>\n</ul>',
            howItWorks:
              '<p><span><strong>Step 1</strong>: Get Global Ledger integration enabled in the AML Watcher - Transaction Watcher solution.</span></p>\n<p><span><strong>Step 2</strong>: Search for any wallet within AML Watcher to get detailed risk information.</span><span></span></p>\n<p><span><strong>Step 3</strong>: You can also put the wallet on monitoring - all without leaving AML Watcher platform.&nbsp;</span></p>',
            howItWorksScreenshotUrl: null,
          },
          {
            slug: 'btguru',
            name: 'BTguru',
            label: 'Unified Risk Report',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=BTguru.svg',
            shortDescription:
              'GL wallet risk assessment within Crypto AML Aggregator Platform',
            order: 13,
            displayIndex: 13,
            category: {
              id: '5',
              name: 'All-In-One Compliance',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              '\n<p>BTguru ChainScreen enables simultaneous querying of multiple crypto AML content providers - including Global Ledger - for real-time transaction monitoring and wallet screening in crypto AML operations</p>\n\n<span>&nbsp;</span>',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/btguru-desc.png',
            keyFeatures:
              '<ul>\n<li><span>A single query to fetch content from multiple crypto AML content providers, including Global Ledger, in a single response.</span></li>\n<li><span>Web service compatible with the integration capabilities of different applications.</span></li>\n<li><span>Customizable according to integration needs.</span></li>\n</ul>',
            howItWorks:
              '<p><strong>Step 1</strong>: Enable Global Ledger integration within BTguru ChainScreen solution.</p>\n<p><strong>Step 2</strong>: Run assessment of a blockchain wallet.</p>\n<p><strong>Step 3</strong>: Obtain a unified risk report from <span>different crypto AML content providers, including<strong> Global Ledger</strong>. Export it in PDF format if needed.</span></p>',
            howItWorksScreenshotUrl: null,
          },
          {
            slug: 'sumsub',
            name: 'Sumsub',
            label: 'Request an Integration',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Sumsub.svg',
            shortDescription:
              'All identity operations under one configurable platform',
            order: 20,
            displayIndex: 20,
            category: {
              id: '5',
              name: 'All-In-One Compliance',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              'Streamline your global compliance requirements by embedding on-chain transaction monitoring directly into Sumsub’s verification ecosystem. Express your interest in this integration to consolidate user identity checks and wallet risk scoring.',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/sumsub-desc.png',
            keyFeatures:
              '<ul>\n<li><strong>360-Degree Compliance Interface:</strong> View KYC, AML screening, and crypto wallet risk profiles side by side.</li>\n<li><strong>Automated Risk Calibration:</strong> Trigger deep-dive transaction checks based on localized regulatory thresholds.</li>\n<li><strong>Unified Audit Trails:</strong> Export singular compliance reports containing both user verification and cryptographic evidence.</li>\n</ul>',
            howItWorks:
              'Help us move this integration to the top of the development queue. Click the <strong>Contact Us</strong> button above to log your request and stay updated on our partnership progress.',
            howItWorksScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/sumsub-how.png',
          },
        ],
      },
      {
        id: '407189021887',
        name: 'KYC',
        slug: 'kyc',
        order: 5,
        items: [
          {
            slug: 'allpass',
            name: 'Allpass',
            label: 'Unified Verification Engine',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=AllPass.svg',
            shortDescription:
              'Streamlined verification process with integrated wallet and transaction risk',
            order: 16,
            displayIndex: 16,
            category: {
              id: '4',
              name: 'KYC',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              '<span>Bridge the gap between identity and blockchain risk. By embedding Global Ledger’s market-leading wallet and transaction intelligence directly into AllPass, you can construct unified, seamless AML verification workflows within a single compliance platform.</span>',
            overviewScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/alpass-desc.png',
            keyFeatures:
              '<ul>\n<li><span><strong>Unified Verification Engine</strong>: Combine traditional identity (KYC) and business (KYB) verification with real-time crypto risk screening.</span></li>\n<li><span><strong>Single-Pane-of-Glass Monitoring</strong>: Access comprehensive KYC results alongside on-chain wallet and transaction risk scores in one dashboard.</span></li>\n<li><span><strong>Drag-and-Drop Workflows</strong>: Easily build custom, logic-based compliance flows tailored to your specific business model and risk tolerance.</span></li>\n</ul>',
            howItWorks:
              '<p><span><strong>Step 1</strong>: Activate the Global Ledger data feed within the Allpass.ai workflow builder. </span></p>\n<p><span><strong>Step 2:</strong> Once enabled, the Allpass.ai platform will automatically fetch and evaluate Global Ledger risk scores for any involved wallets or transactions during your standard user screening process.</span></p>',
            howItWorksScreenshotUrl:
              'https://blog.globalledger.io/hubfs/Integrations/allpass-how.png',
          },
          {
            slug: 'strise',
            name: 'Strise',
            label: 'Request an Integration',
            logoUrl:
              'https://blog.globalledger.io/hubfs/Integrations/integrations-logos/Logo=Strise.svg',
            shortDescription: 'Streamlined KYC and KYB onboarding solution',
            order: 18,
            displayIndex: 18,
            category: {
              id: '4',
              name: 'KYC',
            },
            cta: {
              kind: 'contact_us',
              contactEmail: 'support@glprotocol.com',
              name: 'contact us',
              accessPermissions: [],
            },
            permissions: [],
            overview:
              '<p>Infuse AI-powered onboarding solution with deep blockchain forensics. By connecting Global Ledger data to Strise’s workflows, compliance teams can seamlessly track corporate entities and their associated crypto footprints.</p>\n<p>&nbsp;</p>',
            overviewScreenshotUrl: null,
            keyFeatures:
              '<ul>\n<li><strong>Living Business Records:</strong> Enrich Strise corporate KYB profiles with crypto operations details, as well as real-time wallet tracking and monitoring metrics.</li>\n<li><strong>AI-Driven Alert Triage:</strong> Significantly lower false positives by cross-referencing on-chain risk with corporate UBO mapping.</li>\n<li><strong>Change-Triggered Due Diligence:</strong> Open compliance cases automatically the moment an entity’s associated wallet changes risk status.</li>\n</ul>',
            howItWorks:
              'Ready to bridge institutional FinCrime automation with on-chain reality? Click the <strong>Contact Us</strong> button above to signal your interest to both the Global Ledger and Strise product teams.',
            howItWorksScreenshotUrl: null,
          },
        ],
      },
    ],
  },
}

export default integrationsCatalogMock
